<template>
    <div>
        <div class="card">
            <div class="card-header">
                <div class="row">
                    <div class="col-md-8 align-self-center">
                        Últimos Eventos
                    </div>
                    <div class="col-md-4 text-right">
                        <select class="custom-select custom-select-sm" v-model="filter.tag" @change="load()">
                            <option value="">Mostrar todos os tipos</option>
                            <option value="INFO">Apenas Informações</option>
                            <option value="OKAY">Apenas Sucesso</option>
                            <option value="WARN">Apenas Alertas</option>
                            <option value="ERRO">Apenas Errors</option>
                        </select>
                    </div>
                </div>
            </div>

            <div class="">

                <div class="text-center py-5" v-if="loading">
                    Carregando Eventos ...
                </div>

                <div class="text-center py-5" v-show="events.length == 0 && !loading">
                    Não há eventos ...
                </div>

                <div class="box-events" v-show="events.length > 0 && !loading">
                    <table class="table table-striped table-hover table-md mb-0" v-show="events.length > 0">
                        <tr v-for="event in events" :key="event.id" v-bind:class="classTable(event)">
                            <td>
                                <div class="pl-2">
                                    {{ event.message }}
                                </div>
                            </td>
                            <td class="text-right" width="280px">
                                <div class="pr-2">
                                    <span v-if="event.tag == 'OKAY'" class="badge badge-success">Sucesso</span>
                                    <span v-if="event.tag == 'ERRO'" class="badge badge-danger">Erro</span>
                                    <span v-if="event.tag == 'WARN'" class="badge badge-warning">Alerta</span>
                                    <span v-if="event.tag == 'INFO'" class="badge badge-info">Informação</span>
                                    <span class="ml-2">{{ event.created_at_humans }}</span>
                                </div>
                            </td>
                        </tr>
                    </table>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['player'],
    data() {
        return {
            loading: false,
            events: [],
            time: null,
            filter: {
                tag: ""
            }
        }
    },
    created() {

        // First Load
        this.load(true);

        // Update Date
        this.time = setInterval(() => {
            this.events = this.events.map(m => {
                m.created_at_humans = this.$moment(m.created_at).fromNow();
                return m;
            })
        }, 1000)

        // Listen
        Echo.channel('App.EventPlayer.' + this.player.id)
            .listen('.new-event-from-player', (event) => {
                this.load(false)
            });
    },
    destroyed() {
        Echo.leaveChannel('App.EventPlayer.' + this.player.id);
        clearInterval(this.time)
    },
    methods: {
        // Load
        load(loading = true) {
            if(loading) {
                this.loading = true;
            }
            axios.get('/players/' + this.player.id + '/events/json', {
                params: this.filter
            })
                .then(result => {
                    this.events = result.data.filter(event => event.message !== "Acesso Remoto | O player não está rooteado :(");

                    if(loading) {
                        this.loading = false;
                    }
                })
                .catch(error => {
                    if(loading) {
                        this.loading = false;
                    }
                })
        },
        classTable(event) {
            return {
                'table-success': event.tag == 'OKAY',
                'table-warning': event.tag == 'WARN',
                'table-danger': event.tag == 'ERRO',
                'table-info': event.tag == 'INFO',
            };
        }
    }

}
</script>

<style>
.box-events {
    height: 550px;
    overflow-y: scroll;
    overflow-x: hidden;
}
</style>
